export class readableTelephoneHelper {
    public readableTelephone(tel:string){
        tel = String(tel);

        // 33XXXXXXXXX → +33 X XX XX XX XX
        if (/^33/.test(tel) && tel.length === 11) {
            return tel.replace(
            /^33(\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
            '+33 $1 $2 $3 $4 $5'
            );
        }

        // 0XXXXXXXXX → XX XX XX XX XX
        if (/^0/.test(tel) && tel.length === 10) {
            return tel.replace(
            /^(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
            '$1 $2 $3 $4 $5'
            );
        }

        // XXXXXXXXX → X XX XX XX XX
        if (!/^0/.test(tel) && tel.length === 9) {
            return tel.replace(
            /^(\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
            '$1 $2 $3 $4 $5'
            );
        }

        return tel;
    }

}